import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=a0fbf0fc&scoped=true&"
import script from "./EditProject.vue?vue&type=script&lang=js&"
export * from "./EditProject.vue?vue&type=script&lang=js&"
import style0 from "./EditProject.vue?vue&type=style&index=0&id=a0fbf0fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fbf0fc",
  null
  
)

component.options.__file = "www/vues/admin/controls/EditProject.vue"
export default component.exports